export const SET_LOADING = "SET_LOADING";

export const setLoading = (response) => {
  return {
    type: SET_LOADING,
    payload: response,
  };
};
